import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';

import Avatar from '../Avatar';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, typography, palette }) => ({
    root: {
      display: 'flex',
      color: palette.text.onMain,
      textDecoration: 'none',
    },
    avatarContainer: {
      marginRight: spacing(2),
    },
    userName: {
      fontWeight: typography.fontWeightBold,
      lineHeight: '1.2rem',
    },
    subHeading: {
      color: palette.text.onMain,
      '&::first-letter': {
        textTransform: 'capitalize',
      },
    },

    linked: {
      '& $userName': {
        textDecoration: 'underline',
      },
    },
  })
);

/**
 * @deprecated
 * ### Description
 * `PeopleItem` has been deprecated and replaced by Classify `UserItemDesignation`.
 *
 * ### Example
 * ```
 * import UserItemDesignation from '@classify/react-core-components/UserItemDesignation';
 * ```
 */
export default function PeopleItem({
  userId,
  userName,
  subHeading,
  avatarUrl = null,
  linkComponent: LinkComponent = 'a',
  linkProps = null,
}) {
  const classes = useStyles();

  const content = (
    <>
      <span className={classes.avatarContainer}>
        <Avatar userName={userName} userId={userId} avatarUrl={avatarUrl} />
      </span>
      <span>
        <Typography component="p" className={classes.userName} variant="body">
          {userName}
        </Typography>

        <Typography component="p" variant="bodySmall" className={classes.subHeading}>
          {subHeading}
        </Typography>
      </span>
    </>
  );

  return linkProps ? (
    <LinkComponent {...linkProps} className={`${classes.root} ${classes.linked}`}>
      {content}
    </LinkComponent>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <span {...linkProps} className={classes.root}>
      {content}
    </span>
  );
}
